// 坐标转换服务 API 文档
export default [
	{
		// 1. 单点坐标转换
		name: 'run',
		base: {
			url: '/Coordinate/Run',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 2. 批量坐标转换
		name: 'batchTransform',
		base: {
			url: '/Coordinate/BatchTransform',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 3. 获取坐标系统参数信息
		name: 'getCoordinateSystemParameters',
		base: {
			url: '/Coordinate/CoordinateSystemParameters/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 4. 获取支持的投影类型
		name: 'getSupportedProjections',
		base: {
			url: '/Coordinate/SupportedProjections',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 5. 获取高斯-克吕格投影分带信息
		name: 'getGKZones',
		base: {
			url: '/Coordinate/GKZones',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 6. 获取支持的坐标单位
		name: 'getSupportedUnits',
		base: {
			url: '/Coordinate/SupportedUnits',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 7. 获取投影比例因子信息
		name: 'getScaleFactors',
		base: {
			url: '/Coordinate/ScaleFactors',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},

]